import { gql } from "@apollo/client"

// Fragment containing a summary of the workflow fields used by the list workflows query & create workflow mutation
const WORKFLOW_SUMMARY_FRAGMENT = gql`
  fragment WorkflowFields on Workflow {
    id
    displayId
    name
    status
    createdAt
    dueDate
    type
    severity
    template {
      id
      name
    }
    currentStage {
      ... on WorkflowProcessStage {
        status {
          text
          background
        }
      }
      ... on WorkflowApprovalStage {
        status {
          text
          background
        }
      }
    }
    author {
      id
      fullName
    }
    locations {
      id
      name
    }
    template {
      name
    }
    actions {
      id
      status
    }
  }
`

export { WORKFLOW_SUMMARY_FRAGMENT }
